import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';

import { useAppSelector } from '@app/core/hooks';
import { useCpmsBoGetCustomerQuery } from '@app/core/service/cpms-bo-customer.service';
import { cpmsBoCustomerSlice } from '@app/core/service/cpms-bo-customer.slice';

export interface CustomerFilterStateControllerProps {
  value: GatewayCustomerModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const CustomerFilterStateController = ({
  value,
  onRemove,
}: CustomerFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const customer = useAppSelector((state) =>
    cpmsBoCustomerSlice.selectors.selectById(state, value),
  );

  const { data: customerApiData } = useCpmsBoGetCustomerQuery(value, {
    skip: !!customer,
  });

  const customerName = customer?.name ?? customerApiData?.name ?? '';

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="dataflow-04" label={customerName} onRemove={onRemove} />
  );
};
